﻿module Client.DisplayNumber

open Fable.Core
open PortalLibs.Client.Util
open Fable.React.Helpers
open FSharpPlus
open PortalLibs.Shared

let formatFiniteOrDefVal format defaultVal x =
    if not <| JS.isFinite defaultVal  
    then failwith "Default value must be a finite number."
    let input = if JS.isFinite x then x else defaultVal 
    format input
    
let formatFiniteOrDef format = formatFiniteOrDefVal format Unchecked.defaultof<float>
let formatOptOrEmptyStr format (opt: 'a option) = opt |>> format |> Option.emptyStrIfNone

type AsCurrency () =
  static member std(x: float) = x |> formatNumber false MinusSign true AllZero
  static member std(x: decimal) = x |> float |> AsCurrency.std
  
  static member stdOrDef = formatFiniteOrDef AsCurrency.std
  static member stdStr (x: float) = x |> AsCurrency.std |> str
  
  static member withParenthesis = formatNumber false Parenthesis true AllZero
  static member stdOrEmptyString (x: decimal option) = formatOptOrEmptyStr (AsCurrency.std: decimal -> string) x

type AsNumber() =
  static member std(x: float) = x |> formatNumber false MinusSign false AllZero
  static member std(x: decimal) = x |> float |> AsNumber.std
  static member stdOrDef = formatFiniteOrDef AsNumber.std
  static member stdOrEmptyString (x: decimal option) = formatOptOrEmptyStr (AsNumber.std: decimal -> string) x
  
type AsPercent() =
  static member withParenthesis = formatPercent Parenthesis
  static member withParenthesisOrDef = formatFiniteOrDef AsPercent.withParenthesis 